import React from 'react';
// defaultValue is empty because we're are always using a Provider
export const waveSurferContext = React.createContext({});
export function useWavesurferContext() {
    return React.useContext(waveSurferContext);
}
